import React from 'react';
import { Clock, Target, CheckCircle2, Star } from 'lucide-react';
import { features } from '../data/mock';
import CTAButtons from './CTAButtons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const iconMap = {
  Clock: Clock,
  Target: Target,
  CheckCircle2: CheckCircle2,
  Star: Star
};

const About = () => {
  const renderFeatureCard = (feature, index) => {
    const Icon = iconMap[feature.icon];
    return (
      <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 h-full">
        <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-blue-500 rounded-xl flex items-center justify-center mb-4">
          <Icon className="w-7 h-7 text-white" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
        <p className="text-gray-600 leading-relaxed">{feature.description}</p>
      </div>
    );
  };

  return (
    <section id="about" className="py-24 bg-gradient-to-br from-gray-50 to-emerald-50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <div className="inline-block mb-4 px-4 py-2 bg-emerald-100 text-emerald-800 rounded-full text-xl font-semibold">
              About Us
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Expert Trademark Solutions for Every Brand
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              At Global Trademark USA, we help businesses protect their brand with expert trademark registration services, copyright services, and company formation. Our team ensures your intellectual property is secure quickly and efficiently across the USA.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              We also offer trademark searches and Amazon Brand Registry support, making it easy for you to avoid conflicts and protect your brand. Whether you're just starting or expanding, we're here to help your business thrive.
            </p>
            <CTAButtons />
          </div>
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d"
              alt="Professional consultation"
              className="rounded-2xl shadow-2xl w-full h-auto"
            />
          </div>
        </div>

        {/* Desktop Grid - Hidden on mobile/tablet */}
        <div className="hidden lg:grid grid-cols-4 gap-8">
          {features.map((feature, index) => renderFeatureCard(feature, index))}
        </div>

        {/* Mobile/Tablet Slider - Hidden on desktop */}
        <div className="lg:hidden">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            pagination={{
              clickable: true,
              bulletClass: 'swiper-pagination-bullet !bg-emerald-600',
              bulletActiveClass: 'swiper-pagination-bullet-active'
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20
              }
            }}
            className="about-slider"
          >
            {features.map((feature, index) => (
              <SwiperSlide key={index}>
                {renderFeatureCard(feature, index)}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default About;